"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TabsWithDigitalHig = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ButtonBase = _interopRequireDefault(require("@mui/material/ButtonBase"));

var _caretLeft = _interopRequireDefault(require("@digital-hig/icon/lib/build/ui-controls/caret-left"));

var _Tabs = _interopRequireDefault(require("@mui/material/Tabs"));

var _caretRight = _interopRequireDefault(require("@digital-hig/icon/lib/build/ui-controls/caret-right"));

var _SvgIcon = _interopRequireDefault(require("@mui/material/SvgIcon"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// @to-do: this component needs fixing and restore tests

/* istanbul ignore next */
var TabScrollButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var direction = _ref.direction,
      disabled = _ref.disabled,
      other = _objectWithoutProperties(_ref, ["direction", "disabled"]);

  // remove properties that ButtonBase does not accept
  // eslint-disable-next-line no-unused-vars
  var _slotProps = other.slotProps,
      _slots = other.slots,
      otherProps = _objectWithoutProperties(other, ["slotProps", "slots"]);

  return !disabled && /*#__PURE__*/_react.default.createElement(_ButtonBase.default, _extends({
    ref: ref
  }, otherProps, {
    className: "DhigTabs--scrollButton"
  }), /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
    fontSize: "small"
  }, direction === _constants.directions.LEFT ? /*#__PURE__*/_react.default.createElement(_caretLeft.default, null) : /*#__PURE__*/_react.default.createElement(_caretRight.default, null)));
});
TabScrollButton.displayName = "TabScrollButton";
TabScrollButton.propTypes = {
  direction: _propTypes.default.oneOf(_constants.availableDirections).isRequired,
  disabled: _propTypes.default.bool.isRequired
};

var TabsWithDigitalHig = function TabsWithDigitalHig(BaseMuiTabs) {
  var Tabs = /*#__PURE__*/_react.default.forwardRef(function (_ref2, ref) {
    var children = _ref2.children,
        className = _ref2.className,
        onChange = _ref2.onChange,
        styleVariant = _ref2.styleVariant,
        value = _ref2.value,
        extendedUnderline = _ref2.extendedUnderline,
        otherProps = _objectWithoutProperties(_ref2, ["children", "className", "onChange", "styleVariant", "value", "extendedUnderline"]);

    var muiTabsPresets = {
      // action
      // allowScrollButtonsMobile
      // aria-label
      // aria-labelledby
      // centered
      // children
      // classes
      // component
      // indicatorColor
      // onChange,
      // orientation
      // ScrollButtonComponent
      // scrollButtons
      // selectionFollowsFocus
      // sx
      // TabIndicatorProps
      // TabScrollButtonProps
      // textColor
      // value
      variant: "scrollable" // visibleScrollbar

    };

    var _useState = (0, _react.useState)(value),
        _useState2 = _slicedToArray(_useState, 2),
        selectedValue = _useState2[0],
        setSelectedValue = _useState2[1];

    var handleChange = function handleChange(event, newValue) {
      setSelectedValue(newValue);

      if (onChange) {
        onChange(event, newValue);
      }
    };

    var classnames = className && className.split(" ") || [];
    classnames.push("DhigTabs--styleVariant--".concat(styleVariant));

    if (styleVariant === _constants.styleVariants.QUIET && extendedUnderline) {
      classnames.push("DhigTabs--extendedUnderline");
    } // eslint-disable-next-line react-hooks/rules-of-hooks


    (0, _react.useEffect)(function () {
      /* istanbul ignore next */
      if (value !== selectedValue) {
        setSelectedValue(value);
      } // eslint-disable-next-line react-hooks/exhaustive-deps

    }, [value]);
    return /*#__PURE__*/_react.default.createElement(BaseMuiTabs, _extends({}, muiTabsPresets, otherProps, {
      classes: {
        root: classnames.join(" ")
      },
      onChange: handleChange,
      ref: ref,
      value: selectedValue,
      ScrollButtonComponent: TabScrollButton
    }), children);
  });

  Tabs.displayName = "Tabs";
  Tabs.defaultProps = {
    extendedUnderline: false,
    orientation: "horizontal",
    styleVariant: "default",
    value: 0
  };
  Tabs.propTypes = _objectSpread(_objectSpread({}, _Tabs.default.propTypes), {}, {
    children: _propTypes.default.any.isRequired,
    extendedUnderline: _propTypes.default.bool,
    orientation: _propTypes.default.oneOf(_constants.availableOrientations),
    styleVariant: _propTypes.default.oneOf(_constants.availableStyleVariants)
  });
  return Tabs;
};

exports.TabsWithDigitalHig = TabsWithDigitalHig;
var Tabs = TabsWithDigitalHig(_Tabs.default);
var _default = Tabs;
exports.default = _default;